// extracted by mini-css-extract-plugin
module.exports = {"map":"CustomMap-module--map--1F3os"};